import { render, staticRenderFns } from "./CardBackground.vue?vue&type=template&id=773014ae&scoped=true&"
import script from "./CardBackground.vue?vue&type=script&lang=ts&"
export * from "./CardBackground.vue?vue&type=script&lang=ts&"
import style0 from "./CardBackground.vue?vue&type=style&index=0&id=773014ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773014ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('773014ae', component.options)
    } else {
      api.reload('773014ae', component.options)
    }
    module.hot.accept("./CardBackground.vue?vue&type=template&id=773014ae&scoped=true&", function () {
      api.rerender('773014ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/components/CardBackground.vue"
export default component.exports